import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function AllergyForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [foodItem, setFoodItem] = useState("");
  const [reaction, setReaction] = useState("");
  const [severity, setSeverity] = useState("mild");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!foodItem) return;

    onAdd({
      date: new Date(date).toISOString(),
      foodItem,
      reaction: reaction || "",
      severity,
      notes: notes || "",
    });

    setDate(toDatetimeLocal());
    setFoodItem("");
    setReaction("");
    setSeverity("mild");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date Observed</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Food Item</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Peanuts, Eggs"
            value={foodItem}
            onChange={(e) => setFoodItem(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Reaction</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Hives, vomiting"
            value={reaction}
            onChange={(e) => setReaction(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Severity</label>
          <select
            className="form-select"
            value={severity}
            onChange={(e) => setSeverity(e.target.value)}
          >
            <option value="mild">Mild</option>
            <option value="moderate">Moderate</option>
            <option value="severe">Severe</option>
            <option value="anaphylaxis">Anaphylaxis</option>
          </select>
        </div>
        <div className="col-md-2">
          <label className="form-label">Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Treatment, context"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button type="submit" className="btn btn-danger w-100">
            Log Reaction
          </button>
        </div>
      </div>
    </form>
  );
}
